import { Component, OnInit } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Transfer } from '@safarilaw-webapp/feature/lpms/data-access';
import { safariInjectorMixin } from '@safarilaw-webapp/shared/common-objects-models';

import { AppDialogUiReduxObject, ConfirmationDialogButton, ConfirmationDialogComponent } from '@safarilaw-webapp/shared/dialog/store-access';
import { AbortSave } from '@safarilaw-webapp/shared/redux';

import { NgClass } from '@angular/common';
import { FormControlService } from '@safarilaw-webapp/shared/ui-kit/safari-form';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { catchError, mergeMap, of, throwError } from 'rxjs';
import { ReduxFormId } from '../../../../../../../enums';
import { DocumentTransferNewDialogFormComponent } from './lpms-document-transfer-new-dialog-form.component';

@Component({
  selector: 'sl-lpms-document-transfer-new-dialog',
  templateUrl: './lpms-document-transfer-new-dialog.component.html',
  styleUrls: ['./lpms-document-transfer-new-dialog.component.scss'],
  imports: [DocumentTransferNewDialogFormComponent, NgClass]
})
export class DocumentTransferNewDialogComponent extends safariInjectorMixin(ConfirmationDialogComponent) implements OnInit {
  static ClassId = 'DOCUMENTTRANSFERNEW_DIALOG_COMPONENT-248a7a5a-8a33-4152-8780-aa23325b97bb';
  ConfirmationDialogButton = ConfirmationDialogButton;

  public formApi: FormControlService;
  constructor(dialogReduxObject: AppDialogUiReduxObject, bsModalService: BsModalService, store: Store<any>, actions: Actions, bsModalRef: BsModalRef) {
    super(dialogReduxObject, bsModalService, store, actions, bsModalRef);
    this.formApi = this.inject(FormControlService);
  }

  handleSaveError(err) {
    if (!(err instanceof AbortSave)) {
      return throwError(() => err);
    }

    return of(null);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
  closeModal(dialogButton: ConfirmationDialogButton = ConfirmationDialogButton.Auto) {
    if (dialogButton == ConfirmationDialogButton.Ok) {
      of(null)
        .pipe(
          // Submit (validate form - value returned from the above doesn't matter)
          mergeMap(() => this.formApi.submitOnce$<Transfer>([{ id: ReduxFormId.DocumentTransferNewDialogEdit }], true)),
          // We always have to end with the call to handleSaveError. This function knows
          // not to throw on AbortSave errors, but throw on others (unexpected).
          // In case of AbortSave error it returns NULL which is always used to check in the final
          // subscribe prior to navigating away
          catchError(err => this.handleSaveError(err))
        )
        .subscribe(result => {
          if (result) {
            this.dialogData = result[0].appModel;
            super.closeModal(dialogButton);
          }
        });
    } else {
      super.closeModal(dialogButton);
    }
  }
}
